<div style="display: flex; align-items: center" [ngStyle]="{ height: height }">
  <div *ngIf="isLoading" class="bar-loader" [ngStyle]="{ height: height, width: width, background: currentGradient, borderRadius: roundedCorners ? '12px' : '0' }"></div>
  <div *ngIf="!isLoading && greyBarWhenNotLoading" class="grey-bar-loader" [ngStyle]="{ height: heightGreyBar, width: width, background: greyBarColor }"></div>
</div>
